<div *ngIf="isLoading" class="overlay overlay-block cursor-default modal-body">
    <ng-container>
        <div class="overlay-layer bg-transparent">
            <div class="spinner spinner-lg spinner-success"></div>
        </div>
    </ng-container>
</div>

<div *ngIf="!isLoading">
    <p-carousel [value]="artikel" styleClass="custom-carousel" [numVisible]="4" [numScroll]="1" [circular]="true"
        [autoplayInterval]="5000" [responsiveOptions]="responsiveOptions" [showIndicators]="false">
        <!-- <ng-template pTemplate="header">
            <h5>Circular, AutoPlay, 3 Items per Page and Scroll by 1</h5>
        </ng-template> -->
        <ng-template let-artikel pTemplate="item">
            <div class="product-item" (click)="onOpenArtikelQuickView(artikel)">
                <div class="product-item-content">
                    <div fxLayout="row">
                        <div fxFlex="100">
                            <div class="aktion_a_headline">{{artikel.name}}</div>
                            <div class="aktion_a_headline2">{{artikel.name2}}</div>
                        </div>
                    </div>

                    <div fxLayout="row">
                        <div fxFlex="50">
                            <div class="mb-3">
                                <img src="data:image/jpeg;base64,{{artikel.bildKlein}}"
                                    *ngIf="artikel.bildKlein != null" style="max-height: 50px;" />
                                <img src="{{imgDummy}}" *ngIf="artikel.bildKlein == null"
                                    style="max-height: 33%; max-width: 33%" />
                            </div>
                        </div>
                        <div fxFlex="50">
                            <div>
                                <div class="mt-2">
                                    Art. Nr. {{artikel == null ? artikel.nr : artikel.nr}}
                                </div>
                                <div>
                                    Hersteller Nr. {{artikel == null ? artikel.herstellerNr : artikel.herstellerNr}}
                                </div>


                                <div style="display: flex;">
                                    <div style="width: 100%;">
                                    <div style="text-align: center;">
                                        <div class="price1 mt-2" *ngIf="artikel.wS_Ohneverrechnung == 1"
                                            style="display: flex; height: 41px;">
                                            <div class="info_akt"></div><span style="font-weight: 600;">Preis auf
                                                Anfrage!</span>
                                        </div>
                                    </div>
                                    <div class="price1 mt-2"
                                        *ngIf="artikel.anzeigeNetto != null && artikel.wS_Ohneverrechnung != 1">
                                        {{artikel.matrixArtikel_JN == 'N' ? 'Netto' : 'Netto ab'}}
                                        {{artikel.anzeigeNetto}}
                                        <span>€</span>
                                    </div>
                                    <div *ngIf="artikel.anzeigeBrutto != null && artikel.wS_Ohneverrechnung != 1">
                                        {{artikel.matrixArtikel_JN == 'N' ? 'Brutto' : 'Brutto ab'}}
                                        {{artikel.anzeigeBrutto}}
                                        <span>€</span>
                                    </div>
                                    <div
                                        *ngIf="artikel.rabattfaehig_JN=='J' && artikel.rabatt != null && artikel.rabatt > 0 && artikel.preisNetto > 0 && artikel.wS_Ohneverrechnung != 1">
                                        <span>(inkl. {{artikel.rabatt}}% Rabatt)</span>
                                    </div>
                                </div>
                                <div>
                                    <button mat-mini-fab class="btn_open">
                                        <mat-icon class="matIcon-md mt-1">search</mat-icon>
                                    </button>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </p-carousel>
</div>